import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import eitsApi from '@/apis/eitsApi';
import LoginPageLayout from '@/views/Layout/LoginPageLayout.vue';
import Token from '@/config/token';

var ModifyPassword = /*#__PURE__*/function (_Vue) {
  _inherits(ModifyPassword, _Vue);

  var _super = _createSuper(ModifyPassword);

  function ModifyPassword() {
    _classCallCheck(this, ModifyPassword);

    return _super.apply(this, arguments);
  }

  _createClass(ModifyPassword, [{
    key: "changeBack",
    value: function changeBack(payload) {
      if (payload.type === 'success') {
        this.$router.push({
          path: '/login'
        }); // this.$message.success("密码修改成功,请重新登录");

        localStorage.removeItem('eits-login-authorization');
        this.$store.commit('DEL_TOKEN');
        this.$store.commit('DEL_USER_INFO');
        this.$store.commit('DEL_SKIN');
      }
    }
  }, {
    key: "beforeRouteEnter",
    value: function beforeRouteEnter(to, from, next) {
      console.log('to and from: ', to, from);

      if (to.params.forceModifPwd === 'isWeak') {
        next();
      } else {
        // 页面刷新时登出
        this.$store.dispatch('FedLogOut').then(function () {
          next('/login');
        });
      }
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      // 点击回退按钮时登出
      this.$store.dispatch('FedLogOut').then(function () {
        next();
      });
    }
  }, {
    key: "token",
    get: function get() {
      return Token.getToken();
    }
  }, {
    key: "changePwdUrl",
    get: function get() {
      return eitsApi.UPDATE_PWD_SDK;
    }
  }, {
    key: "challengeCodeUrl",
    get: function get() {
      return eitsApi.CHALLENGE_CODE_SDK;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.$store.getters.userInfo.userName || '';
    }
  }, {
    key: "productCode",
    get: function get() {
      return this.$store.getters.userInfo.productCode || '';
    }
  }]);

  return ModifyPassword;
}(Vue);

ModifyPassword = __decorate([Component({
  components: {
    LoginPageLayout: LoginPageLayout
  }
})], ModifyPassword);
export default ModifyPassword;